'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M16 416c0 44.2 35.8 80 80 80 12.3 0 24.3-2.8 35.2-8.2-12.2-21.1-19.2-45.7-19.2-71.8 0-45.3 21.3-88 57.6-115.2l64-48c4-3 6.4-7.8 6.4-12.8l0-128-96 0 0 128c0 25.2-11.9 48.9-32 64L48 352c-20.1 15.1-32 38.8-32 64zM144 48l0 48 96 0 0-48c0-11.2 1.9-22 5.5-32L176 16c-17.7 0-32 14.3-32 32zm32 368c0 44.2 35.8 80 80 80 17.3 0 34.2-5.6 48-16l115.2-86.4C447.4 372.4 464 339.3 464 304l0-192-160 0 0 128c0 25.2-11.9 48.9-32 64l-64 48c-20.1 15.1-32 38.8-32 64zM304 48l0 48 160 0 0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32z', 'M131.2 487.8c2.7 4.7 5.6 9.2 8.8 13.5-13.5 7-28.6 10.7-44 10.7-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8l64-48C118.5 279.1 128 260.1 128 240l0-192c0-26.5 21.5-48 48-48l76.8 0c-2.9 5.1-5.4 10.4-7.4 16L176 16c-17.7 0-32 14.3-32 32l0 48 96 0 0 16-96 0 0 128c0 25.2-11.9 48.9-32 64L48 352c-20.1 15.1-32 38.8-32 64 0 44.2 35.8 80 80 80 12.3 0 24.3-2.8 35.2-8.2zM304 112l0 128c0 25.2-11.9 48.9-32 64l-64 48c-20.1 15.1-32 38.8-32 64 0 44.2 35.8 80 80 80 17.3 0 34.2-5.6 48-16l115.2-86.4C447.4 372.4 464 339.3 464 304l0-192-160 0zm0-16l160 0 0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 48zM480 48l0 256c0 40.3-19 78.2-51.2 102.4L313.6 492.8c-16.6 12.5-36.8 19.2-57.6 19.2-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8l64-48C278.5 279.1 288 260.1 288 240l0-192c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;